<template>
  <router-link to="/cart" class="cart-control">
    <div class="cart-control__badge">{{ cartItemsCount }}</div>
    <div class="cart-control__icon">
      <svg
        width="24"
        height="19"
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.4203 0.329129C14.7909 0.144125 15.2413 0.294583 15.4263 0.665186L18.5116 6.84571L22.2525 6.84571C22.6667 6.84571 23.0025 7.1815 23.0025 7.59571C23.0025 8.00993 22.6667 8.34571 22.2525 8.34571H21.2662L21.2633 8.36284L20.2264 14.4306C19.816 16.8322 17.7343 18.5883 15.2978 18.5883H8.11736C5.71992 18.5883 3.65989 16.8866 3.20727 14.5323L2.02122 8.36284L2.01792 8.34571H1C0.585786 8.34571 0.25 8.00992 0.25 7.59571C0.25 7.1815 0.585787 6.84571 1 6.84571L4.99344 6.84571L8.18272 0.656616C8.37246 0.288414 8.82476 0.143739 9.19296 0.333476C9.56116 0.523212 9.70584 0.975511 9.5161 1.34371L6.68089 6.84571L16.8351 6.84571L14.0842 1.33514C13.8992 0.964541 14.0497 0.514133 14.4203 0.329129ZM4.6803 14.2491L3.54869 8.36284H19.7415L18.7478 14.1779C18.4605 15.859 17.0034 17.0883 15.2978 17.0883H8.11736C6.43915 17.0883 4.99713 15.8971 4.6803 14.2491Z"
          fill="#2C2C30"
        />
      </svg>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CartControl",
  computed: {
    ...mapGetters(["cartItemsCount"]),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.cart-control {
  position: relative;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;

    svg {
      width: 100%;
    }
  }

  &__badge {
    position: absolute;
    width: 15px;
    height: 15px;
    top: calc(-50%);
    right: calc(-50% + 3px);
    background-color: $action;
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: pxToRem(10);
    line-height: unset;
    font-weight: 600;
  }
}
</style>
